module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(_vm.type !== 'category' && _vm.type != 'category_main' && _vm.type != 'category_main_d') ? _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.list,
      "width": "100%",
      "height": "420",
      "highlight-current-row": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "id",
      "label": "ID",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "title",
      "label": _vm.type == 'store_list' ? '门店名称' : '标题名称'
    }
  }), _vm._v(" "), (_vm.type === 'custom_link') ? _c('el-table-column', {
    attrs: {
      "property": "links",
      "label": "链接"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pager",
    attrs: {
      "page-size": _vm.params.pageSize,
      "layout": "prev, pager, next",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _c('el-table', {
    attrs: {
      "data": _vm.list,
      "height": "420",
      "row-key": "id",
      "default-expand-all": "",
      "highlight-current-row": "",
      "tree-props": {
        children: 'children',
        hasChildren: 'hasChildren'
      }
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "分类名"
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01c63e12", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c63e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_links/comps/list.vue
// module id = 2422
// module chunks = 0